/**
 * 表の行の高さの切り替え(設計書 §4-1: 標準 44px / 詰める 36px は「明示的な表示切替時のみ」)。
 * 選んだ高さは利用者のブラウザに覚える(使えないときは毎回「標準」)。業務ロジックは持たない。
 */
import { useState } from 'react';
import SegmentedControl from './SegmentedControl';

export type Density = 'standard' | 'compact';

export function useTableDensity(storageKey: string): [Density, (d: Density) => void] {
  const [density, setDensity] = useState<Density>(() => {
    try {
      return localStorage.getItem(storageKey) === 'compact' ? 'compact' : 'standard';
    } catch {
      return 'standard';
    }
  });
  const set = (d: Density) => {
    setDensity(d);
    try {
      localStorage.setItem(storageKey, d);
    } catch {
      /* 保存できなくても表示は切り替える */
    }
  };
  return [density, set];
}

export default function TableDensity({ value, onChange }: { value: Density; onChange: (d: Density) => void }) {
  return (
    <SegmentedControl
      label="行の高さ"
      showLabel
      size="sm"
      options={[
        { key: 'standard', label: '標準' },
        { key: 'compact', label: '詰める' },
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
